// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project_doc_view {
  width: 283px;
  height: 372px;
  margin-bottom: 4em;
}

.doc_view {
  font-style: italic;
  font-weight: 400;
  align-items: center;
  top: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.doc_view__options {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  bottom: -2em;
  height: 2em;
}
.doc_view__options button {
  border: 0;
  background: transparent;
  cursor: pointer;
}
.doc_view__options button:disabled {
  opacity: 50%;
  cursor: default;
}
.doc_view__visibility {
  display: flex;
  align-items: center;
}
.doc_view__download {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.doc_view__download p {
  display: inline;
}
.doc_view__download.pdf {
  position: absolute;
  right: 0;
  bottom: -2.3em;
}
.doc_view .doc_control_btn {
  background: none;
  border: 0;
}
.doc_view .doc_control_btn:disabled {
  opacity: 50%;
}
.doc_view .page-control-bar {
  position: absolute;
  bottom: -1.9em;
  display: flex;
  width: 100%;
  justify-content: center;
}
.doc_view .page-control-bar .page-control-bar__container {
  display: flex;
}
.doc_view .checked {
  opacity: 100%;
}

.doc_view__visibility {
  display: flex;
  align-items: center;
}
.doc_view__visibility button {
  opacity: "70%";
}
.doc_view__visibility button:disabled {
  opacity: 50%;
  cursor: default;
}

.disable {
  opacity: 50%;
}

.doc_view__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #a3b9d9;
}

.error_doc_view {
  position: absolute;
  top: 45%;
  width: 100%;
  text-align: center;
  word-wrap: break-word;
}

.image_container_project-doc {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.image_container_project-doc img {
  object-fit: cover;
}

@media screen and (max-width: 1440px) {
  .project_doc_view {
    width: 254.7px;
    height: 334.8px;
  }
}
@media screen and (min-width: 1805px) {
  .project_doc_view {
    width: 367.9px;
    height: 483.6px;
  }
}
@media screen and (min-width: 1900px) {
  .project_doc_view {
    width: 396.2px;
    height: 558px;
  }
}
.kpPreview__box .doc_view__options {
  bottom: 1em;
}`, "",{"version":3,"sources":["webpack://./src/Components/conteiners/DocumentView/src/DocumentView.scss"],"names":[],"mappings":"AAGA;EACE,YAJU;EAKV,aAJW;EAKX,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AADJ;AAEI;EACE,SAAA;EACA,uBAAA;EACA,eAAA;AAAN;AACM;EACE,YAAA;EACA,eAAA;AACR;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAZJ;AAaI;EACE,eAAA;AAXN;AAcI;EACE,kBAAA;EACA,QAAA;EACA,cAAA;AAZN;AAeE;EACE,gBAAA;EACA,SAAA;AAbJ;AAcI;EACE,YAAA;AAZN;AAeE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EAGA,uBAAA;AAfJ;AAiBI;EACE,aAAA;AAfN;AAkBE;EACE,aAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,cAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,eAAA;AAlBJ;;AAwBA;EACE,YAAA;AArBF;;AAuBA;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EAEA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,kBAAA;EACA,qBAAA;AAvBF;;AAyBA;EACE,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,gBAAA;AAvBF;AAwBE;EACE,iBAAA;AAtBJ;;AA0BA;EACE;IACE,cAAA;IACA,eAAA;EAvBF;AACF;AA8BA;EACE;IACE,cAAA;IACA,eAAA;EA5BF;AACF;AAmCA;EACE;IACE,cAAA;IACA,aAAA;EAjCF;AACF;AAwCA;EACE,WAAA;AAtCF","sourcesContent":["$doc-width: 283px;\n$doc-height: 372px;\n\n.project_doc_view {\n  width: $doc-width;\n  height: $doc-height;\n  margin-bottom: 4em;\n}\n\n.doc_view {\n  font-style: italic;\n  font-weight: 400;\n  align-items: center;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  &__options {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    position: absolute;\n    bottom: -2em;\n    height: 2em;\n    button {\n      border: 0;\n      background: transparent;\n      cursor: pointer;\n      &:disabled {\n        opacity: 50%;\n        cursor: default;\n      }\n    }\n  }\n  &__visibility {\n    display: flex;\n    align-items: center;\n    // &:disabled{\n    //         opacity: 50%;\n    //         cursor:default;\n    //     }\n    img {\n      // &:last-child {\n      //     margin-left: 15px;\n      // }\n    }\n  }\n  .eyeIcon {\n  }\n  &__download {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    p {\n      display: inline;\n    }\n\n    &.pdf {\n      position: absolute;\n      right: 0;\n      bottom: -2.3em;\n    }\n  }\n  .doc_control_btn {\n    background: none;\n    border: 0;\n    &:disabled {\n      opacity: 50%;\n    }\n  }\n  .page-control-bar {\n    position: absolute;\n    bottom: -1.9em;\n    display: flex;\n    width: 100%;\n\n    // margin: 0 auto;\n    justify-content: center;\n\n    .page-control-bar__container {\n      display: flex;\n    }\n  }\n  .checked {\n    opacity: 100%;\n  }\n}\n\n.doc_view__visibility {\n  display: flex;\n  align-items: center;\n\n  & button {\n    opacity: \"70%\";\n  }\n\n  & button:disabled {\n    opacity: 50%;\n    cursor: default;\n  }\n}\n\n._control_btn {\n}\n.disable {\n  opacity: 50%;\n}\n.doc_view__container {\n  // min-height: 386px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  // height: $doc-height;\n  height: 100%;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px solid #a3b9d9;\n}\n\n.error_doc_view {\n  position: absolute;\n  top: 45%;\n  width: 100%;\n  // margin: 0 2em;\n  text-align: center;\n  word-wrap: break-word;\n}\n.image_container_project-doc {\n  width: 100%;\n  // height: $doc-height;\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n  img {\n    object-fit: cover;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .project_doc_view {\n    width: calc($doc-width * 0.9);\n    height: calc($doc-height * 0.9);\n  }\n  // .doc_view__container{\n  //     width: calc($doc-width * 1.3);\n  //     height: calc($doc-height * 1.3);\n  // }\n}\n\n@media screen and (min-width: 1805px) {\n  .project_doc_view {\n    width: calc($doc-width * 1.3);\n    height: calc($doc-height * 1.3);\n  }\n  // .doc_view__container{\n  //     width: calc($doc-width * 1.3);\n  //     height: calc($doc-height * 1.3);\n  // }\n}\n\n@media screen and (min-width: 1900px) {\n  .project_doc_view {\n    width: calc($doc-width * 1.4);\n    height: calc($doc-height * 1.5);\n  }\n  // .doc_view__container{\n  //     width: calc($doc-width * 1.4);\n  //     height: calc($doc-height * 1.4);\n  // }\n}\n\n.kpPreview__box .doc_view__options {\n  bottom: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
